import { getAnalytics, logEvent } from 'firebase/analytics';

export default function useEventPlayList(category_nr) {
  const analytics = getAnalytics();
  logEvent(analytics, 'view_lists_' + category_nr);
}
